import { AxiosResponse } from "axios";

import { createSliceSaga } from "../saga-helper";
import { call, put, select } from "redux-saga/effects";
import { AdCopiesReducerAction } from "./slice";
import { adCopiesSelector } from "./selector";
import { AdCopiesListType } from "./types";
import {
  AdCopiesMetricsDetailsService,
  AdCopiesInsightDetailsService,
  AdCopiesService,
  DropdownListService,
  PostAdCopiesMetricsService,
} from "../../services/AdCopiesService";
import { SORT } from "../../types/adCopiesFilterTypes";

const saga = createSliceSaga({
  name: "adcopies-saga-state",
  caseSagas: {
    *getAdCopies(action: {
      payload: {
        provider: string;
        start_date: string;
        end_date: string;
        skip: number;
        limit: number;
        creative_type: string[];
        status: string[];
        platform: string;
        sorting: SORT;
        indication: string[];
        campaign_ids: string[];
      };
      type: string;
    }) {
      try {
        const adCopiesList: AdCopiesListType = yield select(adCopiesSelector);
        yield put(AdCopiesReducerAction.setIsLoading(true));
        // Step-2: Calling the Service file API and setting the data in reducer
        const { data: apiResponse, status }: AxiosResponse = yield call(
          AdCopiesService,
          action.payload
        );

        if (status === 200) {
          let responseData = apiResponse["ad-copies"];

          if (adCopiesList["ad-copies"].length > 0 && responseData.length > 0)
            responseData = [...adCopiesList["ad-copies"], ...responseData];

          yield put(
            AdCopiesReducerAction.setAdCopies({
              total: apiResponse.total ?? 0,
              "ad-copies": responseData,
            })
          );
        }
      } catch (error) {
        console.error("Error fetching Ad-Copies!");
      } finally {
        yield put(AdCopiesReducerAction.setIsLoading(false));
      }
    },
    *getDropdownList() {
      try {
        const { data: apiResponse, status }: AxiosResponse = yield call(
          DropdownListService
        );

        if (status === 200) {
          yield put(
            AdCopiesReducerAction.setDropdownList({
              total: apiResponse.total ?? 0,
              dropdown: apiResponse.data,
            })
          );
        }
      } catch (error) {
        console.error("Error fetching dropdown list");
      }
    },
    *getAdCopiesMetricDetails(action: {
      payload: {
        ad_details_id: number;
      };
      type: string;
    }) {
      try {
        yield put(AdCopiesReducerAction.setIsLoadingForDetails(true));

        const { data: apiResponse, status }: AxiosResponse = yield call(
          AdCopiesMetricsDetailsService,
          action.payload
        );

        if (status === 200) {
          yield put(
            AdCopiesReducerAction.setAdCopiesMetricsDetails(
              apiResponse["ad-copy"]
            )
          );
        }
      } catch (error) {
        console.error("Error fetching Ad Creatives Metrics Details");
      } finally {
        yield put(AdCopiesReducerAction.setIsLoadingForDetails(false));
      }
    },
    *getAdCopiesInsightDetails(action: {
      payload: {
        ad_details_id: number;
      };
      type: string;
    }) {
      try {
        yield put(AdCopiesReducerAction.setIsLoadingForDetails(true));

        const { data: apiResponse, status }: AxiosResponse = yield call(
          AdCopiesInsightDetailsService,
          action.payload
        );

        if (status === 200) {
          yield put(
            AdCopiesReducerAction.setAdCopiesDetails(apiResponse["ad-copy"])
          );
        }
      } catch (error) {
        console.error("Error fetching Ad Creatives Details");
      } finally {
        yield put(AdCopiesReducerAction.setIsLoadingForDetails(false));
      }
    },
    *postAdCopiesMetrics(action: {
      payload: {
        ad_details_id: string;
        metrics: Array<string>;
        resolve: () => void;
      };
    }) {
      const { ad_details_id, metrics, resolve } = action.payload;

      const formData: any = new FormData();
      formData.append("ad_details_id", ad_details_id);
      metrics.forEach((matricId) => {
        formData.append("metric_type[]", matricId);
      });

      try {
        yield put(AdCopiesReducerAction.setIsButtonLoading(true));

        const { status }: AxiosResponse = yield call(
          PostAdCopiesMetricsService,
          formData
        );

        if (status === 200) {
          // yield put(AdCopiesReducerAction.setAdCopiesSkip(0));
        }
      } catch (error) {
        console.error("Error generating Ad Creatives.");
      } finally {
        if (resolve) {
          resolve();
        }
        yield put(AdCopiesReducerAction.setIsButtonLoading(false));
      }
    },
  },
  sagaType: "takeEvery",
});

export const {
  actions: AdCopiesSagaAction,
  saga: AdCopiesSaga,
  name: AdCopiesSagaName,
} = saga;
